const ns = "CREDENTIALS_MODULES_COUNTS";

export const ADD_COUNT = `${ns}_ADD_COUNT`;
